import { render, staticRenderFns } from "./ShortDescription.vue?vue&type=template&id=cbe54624&scoped=true&lang=pug"
import script from "./ShortDescription.vue?vue&type=script&lang=js"
export * from "./ShortDescription.vue?vue&type=script&lang=js"
import style0 from "./ShortDescription.vue?vue&type=style&index=0&id=cbe54624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe54624",
  null
  
)

export default component.exports